import React from 'react';
import _InfoIcon from '@material-ui/icons/Info';
import styled from 'styled-components/macro';

const OuterDiv = styled.div`
  align-self: center;
  background-color: #dfeafc;
  border-left: 3px solid #4c8cf6;
  color: #4c8cf6;
  flex: 1;
  height: 3rem;
  padding: 0.5rem;
`;

const InfoIcon = styled(_InfoIcon)`
  font-size: 1.5rem;
  vertical-align: bottom;
`;

const ViewOnlyBannerView = props => {
  return (
    <OuterDiv>
      <InfoIcon /> Submission is set to <strong>View only:</strong> The entered
      data is not editable.
    </OuterDiv>
  );
};

export default ViewOnlyBannerView;
